import {useEffect} from "react";
import {useLocation} from "react-router-dom";

export function useBrowserTitle(title) {
    const location = useLocation()

    useEffect(() => {
        document.title = title ? `AltraBits - ${title}` : 'AltraBits'
    }, [location]);

    return null;
}